import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import LogoWide from '../../assets/images/logo-wide.png';
import useBodyClass from '../../hooks/useBodyClass';

const ForgotPassword = ({ email, onForgotPassword, onEmailChange }) => {
  useBodyClass('unauthenticated-page');

  const onSubmitForm = event => {
    event.preventDefault();
    onForgotPassword(email);
  };

  return (
    <div className="unauthenticated">
      <div className="unauthenticated__logo">
        <img src={LogoWide} alt="Pivot Logo" title="Pivot Logo" />
      </div>
      <div className="box">
        <hgroup className="unauthenticated__header">
          <h1>Reset Password</h1>
        </hgroup>

        <form
          className="unauthenticated__form"
          onSubmit={event => onSubmitForm(event)}
        >
          <div className="form-group">
            <input
              className="required"
              type="email"
              name="email"
              autoComplete="email"
              placeholder="Email Address"
              required
              value={email}
              onChange={e => onEmailChange(e.target.value)}
              data-testid="forgot-password-form-email"
            />
          </div>

          <button
            type="Submit"
            className="btn-primary is-block"
            data-testid="forgot-password-form-submit"
          >
            Reset My Password
          </button>

          <p className="unauthenticated__link">
            <Link to={'/login'} className="link--secondary">
              Login
            </Link>
          </p>
        </form>
      </div>

      <p className="unauthenticated__link">
        <a href="/contact" className="link--negative">
          Don't have an account? <u>Contact Us</u>
        </a>
      </p>
    </div>
  );
};

ForgotPassword.propTypes = {
  email: PropTypes.string,
  onForgotPassword: PropTypes.func,
  onEmailChange: PropTypes.func,
};

export default ForgotPassword;
